import Text from '@deprecated-ui/common/Text';
import moment from 'moment';
import Image from 'global/Image';
import { InfoWrapper } from '../styled';

interface Props {
  until: string;
}

function Info({ until }: Props) {
  return (
    // @ts-expect-error
    <InfoWrapper p="12px 16px" align="center" justify="flex-start" mt="16px">
      <Image
        alt="info"
        src="/images/community/info.svg"
        width="16px"
        height="16px"
      />
      {/* @ts-expect-error */}
      <Text ml="8px" size="12px" height="16px" as="span">
        Kode komunitas tidak dapat diubah atau dihapus selama tiga bulan setelah
        aktivasi hingga{' '}
        <Text size="12px" height="16px" family="bold" as="span">
          {moment(until).format('DD MMM YYYY')}.
        </Text>
      </Text>
    </InfoWrapper>
  );
}

export default Info;
